module.exports = __webpack_public_path__ + "static/media/media-four.3058fba8.png";